import React from "react";
import {
  categoryIconStyles,
  defaultCategoryIconStyle,
} from "src/layouts/MyAccount/Notifications/NotificationInterfaces";
import "./NotificationCategoryIcon.scss";

interface NotificationCategoryIconProps {
  category: string;
  className?: string;
  iconSize?: number;
}

// Shared icon+color badge for a notification's category — used by both the
// header bell popup and the All Notifications page so the two surfaces stay
// visually in sync. Backed by the `categoryIconStyles` map (NotificationInterfaces.tsx);
// add new categories there, not here.
const NotificationCategoryIcon: React.FC<NotificationCategoryIconProps> = ({
  category,
  className = "",
  iconSize = 20,
}) => {
  const { Icon, modifier } = categoryIconStyles[category] ?? defaultCategoryIconStyle;

  return (
    <span
      className={`notification-category-icon notification-category-icon--${modifier} ${className}`.trim()}
    >
      <Icon size={iconSize} aria-hidden />
    </span>
  );
};

export default NotificationCategoryIcon;
